import tickImage from "../assets/images/double-tick.png";
import noteImage from "../assets/images/notes.png";
import plusImage from "../assets/images/plus.png";
import { Bars } from "react-loader-spinner";
import { Rings } from "react-loader-spinner";
import {
  useAddTodoMutation,
  useChangeMultipleTodoStatusMutation,
  useClearAllCompletedTodoMutation,
} from "../features/api/apiSlice";
import * as React from "react";

export default function Header() {
  const [text, setText] = React.useState("");

  const [addTodo, { data: data2, isLoading, isError, isSuccess }] =
    useAddTodoMutation();

  const [changeMultipleTodoStatus, { isLoading: statusChangeLoading }] =
    useChangeMultipleTodoStatusMutation();

  const [clearAllCompletedTodo, { isLoading: completeTodoLoading }] =
    useClearAllCompletedTodoMutation();
  const handleMultipleTodoStatusChange = () => {
    changeMultipleTodoStatus();
  };

  const handleClearAllCompletedTodo = () => {
    clearAllCompletedTodo();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    addTodo({
      text,
      completed: false,
      color: "",
    });
    setText("");
  };
  return (
    <div>
      <form
        className="flex items-center bg-gray-100 px-4 py-4 rounded-md"
        onSubmit={handleSubmit}
      >
        <img src={noteImage} className="w-6 h-6" alt="Add todo" />
        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Type your todo"
          className="w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500"
        />
        {isLoading ? (
          <Bars
            height="20"
            width="30"
            color="#4fa94d"
            ariaLabel="bars-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        ) : (
          <button
            type="submit"
            className={`appearance-none w-8 h-8 bg-[url('${plusImage}')] bg-no-repeat bg-contain`}
          ></button>
        )}
      </form>

      <ul className="flex justify-between my-4 text-xs text-gray-500">
        {statusChangeLoading ? (
          <Rings
            height="20"
            width="20"
            color="#4fa94d"
            radius="6"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="rings-loading"
          />
        ) : (
          <li
            className="flex space-x-1 cursor-pointer"
            onClick={handleMultipleTodoStatusChange}
          >
            <img className="w-4 h-4" src={tickImage} alt="Complete" />
            <span>Complete All Tasks</span>
          </li>
        )}

        {completeTodoLoading ? (
          <Rings
            height="20"
            width="20"
            color="#4fa94d"
            radius="6"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="rings-loading"
          />
        ) : (
          <li onClick={handleClearAllCompletedTodo} className="cursor-pointer">
            Clear completed
          </li>
        )}
      </ul>
    </div>
  );
}
